<!-- Top Sales -->
<template>
  <div 
    v-if="userInfo && userInfo.OGN_FG === '00' "
    class="info-section"
  >
    <div class="info-label">FC</div>
    <select
      v-model="selectedBranch"
      class="branch-select"
      :disabled="userInfo && userInfo.OGN_FG === '01'"
    >
      <option
        v-for="branch in branchList"
        :key="branch.BRANCH_CD"
        :value="branch.BRANCH_CD"
      >
        {{ branch.BRANCH_NM }}
      </option>
    </select>
    <div class="info-label">매장명</div>
    <input
      list="team-datalist"
      v-model="teamSearch"
      @change="handleTeamSelection"
      class="team-select"
      placeholder="매장 검색 또는 선택"
      :disabled="userInfo && userInfo.OGN_FG === '01'"
    />
    <datalist id="team-datalist">
      <option
        v-for="team in teamList"
        :key="team.SHOP_CD"
        :value="`(${team.VAN_BIZ_NO}) ${team.SHOP_NM}`"
      />
    </datalist>
    <div class="button-group">
      <button
        v-if="isSaveButtonVisible"
        class="tsList-button"
        @click="saveDeleteFlag()"
      >
        삭제여부: {{ deleteFlag }}
      </button>
      <!-- <button
        v-if="isSaveButtonVisible"
        class="tsList-button"
        @click="saveGridData(monthlyTop20GridApi)"
      >
        저장
      </button>
      <button
        v-if="isSaveButtonVisible"
        class="tsList-button"
        @click="copyMonthlyTop20Data"
      >
        복사
      </button> -->
    </div>
  </div>        
  <div class="ts-list-page">
    <div class="ts-list-middle-table">
      <ag-grid-vue
        class="ag-ts-balham monthly-grid"
        :style="{ width: '100%', height: gridHeight + 'rem' }"
        :rowData="monthlyTop20Data"
        :columnDefs="monthlyTop20Defs"
        :theme="theme"
        :gridOptions="monthlyTop20GridOptions"
        :rowHeight="rowHeight"
        @grid-ready="onMonthlyTop20GridReady"
      />
    </div>
    <!-- ====================== 청약방법 ====================== -->
    <div class="meeting-wrap">

      <table class="meeting-info">
        <tbody>
        <tr>
          <th>사업주 되는 방법과 청약 방법</th>
        </tr>
        </tbody>
      </table>

      <table class="meeting-table">
        <tbody>
          <tr>
            <td style="width:70px;" class="no">1</td>
            <td colspan="2">
              {{previousMonth}}월 한달간 사업소득 20위를 공개합니다. 사업을 잘한 사업주는 의사보다 많이 벌고 있습니다.
              {{previousMonth}}월 사업소득 1위 사업주는 {{ top1Data?.AGE }}세 {{ top1Data?.EMP_NM }} {{ top1Data?.SHOP_NM }} 사업주이며 {{ Number(top1Data?.AMT_SUM).toLocaleString() }}만원 벌었고
              제일 나이가 적은 사업주는 {{ youngestData?.AGE }}세 {{ youngestData?.EMP_NM }} {{ youngestData?.SHOP_NM }} 사업주이며 {{ Number(youngestData?.AMT_SUM).toLocaleString() }}만원을 벌었습니다.
              돈 많이 버는 사업주들 처럼 돈 많이 버는 사업주가 되겠다고 다짐하고 목표를 정하면 모든일이 즐겁고 성공 속도가 빨라집니다.
            </td>
          </tr>

          <tr>
            <td class="no">2</td>
            <td colspan="2">사업주 청약 대기자 모집으로 누구든지 기회가 있습니다. ※사업주 청약 문의) 010-9921-7181</td>
          </tr>

          <tr>
            <td class="no">3</td>
            <td colspan="2">
              나이, 학력, 경력에 관계없이 타이어 업계 1년 이상이면 청약 가능합니다. 
              ※ 베스트 사업왕 수수료: 매월 1~10위 100만원 / 11~20위 50만원 추가 수수료 있습니다.
            </td>
          </tr>
          
          <tr>
            <td class="no">4</td>
            <!-- <td colspan="1" style="width:40%;">사회 경력 및 타이어 업종경력과 한줄 본인소개</td> 260915 질문변경-->
            <td colspan="1" style="width:40%;">어떻게 해야 성공 사업주가 될 수 있다고 생각하는지요?</td>
            <td colspan="1"><textarea style="width: 95%;" rows="1" v-model="formData.SELF_INTRO"></textarea></td>
          </tr>

          <tr>
            <td class="no">5</td>
            <!-- <td colspan="2">사업주당 3개월 이상씩, 3명 이상의 사업주로부터 사업을 배운자는 가점이 있습니다.</td> 260915 내용변경-->
            <!-- <td colspan="2">사업주당 3개월 이상씩, 3명 이상의 사업주로부터 사업을 배운자는 가점이 있고 3명 이상 추천이 있으면 추가 가점이 있습니다.</td> 260929 내용변경-->
            <td colspan="2">사업주당 3개월 이상씩, 3명 이상의 사업주로부터 사업을 배운자는 가점이 있고 여러 사업주에게 배우고 3명 이상 추천이 있으면 추가 가점이 있습니다.</td>
          </tr>

          <tr>
            <td class="no">6</td>
            <!-- <td colspan="2">3명 이상이 추천이 있으면 가점이 있습니다.&nbsp;사업 보증금 1천만원을 준비해 놓아야 합니다.</td> 260915 내용변경-->
             <td style="width:40%; text-align:left;">
              사업주 청약 보증금 1천만원 중 얼마를 준비 했습니까?
            </td>
            <td style="width:60%; vertical-align:middle;">
              <div class="radio-line">
                <div class="amount-box">
                  <input
                    type="number"
                    v-model="formData.PROFIT_AMOUNT"
                    placeholder="금액(만원)"
                    style="text-align: right;"
                  />
                  <span>만원</span>
                </div>
                <label>
                  <input 
                    type="radio" 
                    value="1" 
                    v-model="formData.PROFIT_READY" 
                  />현 사업주(보증금 완납)
                </label>
              </div>
            </td>
          </tr>

          <tr>
            <td class="no">7</td>
            <td style="width:40%; text-align:left;">
              사업주가 되어 돈을 많이 벌고 싶은 욕구가 있는지?
            </td>
            <td style="width:60%; vertical-align:middle;">
              <div class="radio-group">
                <label><input type="radio" value="1" v-model="formData.WANT_PROFIT_LEVEL" /> 매우 많다</label>
                <label><input type="radio" value="2" v-model="formData.WANT_PROFIT_LEVEL" /> 보통이다</label>
                <label><input type="radio" value="3" v-model="formData.WANT_PROFIT_LEVEL" /> 욕구가 없다</label>
              </div>
            </td>
          </tr>

          <tr>
            <td class="no">8</td>
            <td style="width:40%; text-align:left;">
              사업주 욕구가 많다면 언제쯤 사업주 모집에 청약할 것인지?
            </td>
            <td style="width:60%; vertical-align:middle;">
              <div class="radio-group">
                <label><input type="radio" value="1" v-model="formData.APPLY_PLAN" /> 즉시</label>
                <label><input type="radio" value="2" v-model="formData.APPLY_PLAN" /> 6개월 안에</label>
                <label><input type="radio" value="3" v-model="formData.APPLY_PLAN" /> 1년 안에</label>
              </div>
            </td>
          </tr>

          <tr>
            <td class="no">9</td>
            <td style="width:40%; text-align:left;">
              만약 사업주가 된다면 연간 벌고 싶은 금액은?
            </td>
            <td style="width:60%; vertical-align:middle;">
              <div class="radio-group">
                <label><input type="radio" value="1" v-model="formData.WANT_INCOME" /> 1억원 이상</label>
                <label><input type="radio" value="2" v-model="formData.WANT_INCOME" /> 7천만원 이상</label>
                <label><input type="radio" value="3" v-model="formData.WANT_INCOME" /> 5천만원 이상</label>
              </div>
            </td>
          </tr>

          <tr>
            <td class="no">10</td>
            <td style="width:40%; text-align:left;">
              연간 1억 이상 버는 사업주를 몇명이나 알고 있습니까?
            </td>
            <td style="width:60%; vertical-align:middle;">
              <div class="radio-group">
                <label><input type="radio" value="1" v-model="formData.KNOW_TOP_EARNERS" /> 5명 이상</label>
                <label><input type="radio" value="2" v-model="formData.KNOW_TOP_EARNERS" /> 2명 이상</label>
                <label><input type="radio" value="3" v-model="formData.KNOW_TOP_EARNERS" /> 없음</label>
              </div>
            </td>
          </tr>

          <tr>
            <td class="no">11</td>
            <td style="width:40%; text-align:left;">
              <!-- 사업주 해보라고 권유나 권고 받아 본적이 있습니까?  260929 내용변경 -->
              사업주 하면 {{ nextMonth }}월에 몇개를 팔아 얼마를 벌고 싶습니까?
            </td>
            <td style="width:60%; vertical-align:middle;">
              <!-- <div class="radio-group">
                <label><input type="radio" value="1" v-model="formData.RECOMMEND_EXPERIENCE" /> 매우 많다</label>
                <label><input type="radio" value="2" v-model="formData.RECOMMEND_EXPERIENCE" /> 한두번 있다</label>
                <label><input type="radio" value="3" v-model="formData.RECOMMEND_EXPERIENCE" /> 전혀 없다</label>
              </div> 260929 내용변경 -->
                <div class="radio-line">
                  <div class="amount-box">
                    팔고싶은 수량
                    <input
                      type="number"
                      v-model="formData.WANT_CNT"
                      placeholder="(개)"
                      style="text-align: right;"
                    />
                    <span>개</span>
                  </div>
                  <div class="amount-box">
                    벌고싶은 금액
                    <input
                      type="number"
                      v-model="formData.WANT_AMOUNT"
                      placeholder="(만원)"
                      style="text-align: right;"
                    />
                    <span>만원</span>
                  </div>
                </div>
            </td>
          </tr>

          <tr>
            <td class="no">12</td>
            <!-- <td colspan="1" style="width:40%;">사업주 해보라고 권유한 사람은 누구누구입니까?</td> 260929 내용변경 -->
            <td colspan="1" style="width:40%;">돈을 많이 벌 수 있다고 하면서 사업주 해보라고 권유한 사람은 누구누구입니까?</td>
            <td colspan="1">
              <input
                v-for="(item, index) in 5"
                :key="index"
                v-model="formData.RECOMMENDER[index]"
                style="width:18%; margin-right:2px;"
              />
            </td>
          </tr>
        </tbody>
      </table>

      <div class="sign-table">
        <!-- 1. 성공사업주 내용 -->
        <table class="memo-table">
          <tbody>
            <tr>
              <!-- <th>
                성공사업주가 되기<br>
                위해 하고 있는 것이<br>
                있는지요
              </th> 260929 내용변경 -->
              <th>
                사업소득 20위와<br>
                같이 돈을 많이 버는<br>
                사업주를 보면<br>
                어떤 생각이 드는지요
              </th>
              <!-- HOW_SUCCESS 260915 추가 -->
              <td>
                <textarea
                  id="memo"
                  v-model="formData.HOW_SUCCESS"
                  class="memo-input"
                ></textarea>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- 2. 정보 입력 -->
        <table class="info-table">
          <tbody>
            <tr>
              <th>점번</th>
              <td>
                <input
                  v-model="formData.VAN_BIZ_NO"
                  readonly
                >
              </td>

              <th>연락처</th>
              <td>
                <input
                  v-model="formData.TEL_NO"
                  placeholder="01012345678"
                  maxlength="13"
                  @input="formData.TEL_NO = formatPhoneValue(formData.TEL_NO)"
                >
              </td>
            </tr>

            <tr>
              <th>점명</th>
              <td>
                <input
                  v-model="formData.SHOP_NM"
                  readonly
                >
              </td>

              <th>타이어경력</th>
              <td>
                <div class="career-box">
                  <input
                    type="number"
                    v-model="formData.CAREER"
                  >
                  <span>개월</span>
                </div>
              </td>
            </tr>

            <tr>
              <th>나이</th>
              <td>
                <input
                  type="number"
                  v-model="formData.AGE"
                >
              </td>

              <th>작성일자</th>
              <td>
                <input
                  v-model="formData.REG_DT"
                >
              </td>
            </tr>
          </tbody>
        </table>

        <!-- 3. 서명 -->
        <div class="sign-row">
        <!-- 작성자 이름과 성명은 한 줄 -->
          <div class="sign-name">
            <label>작성자 서명</label>
            <input v-model="formData.SIGN_NM">
          </div>

          <!-- 이미지 영역은 아래 줄 -->
          <div class="sign-image">
            <img
              v-if="formData.USER_SIGN"
              :src="formData.USER_SIGN"
              alt="서명 이미지"
            >
            <div v-else class="placeholder">
              서명 없음
            </div>
          </div>
        </div>

      </div>
      <div class="signature-row" v-if="userInfo && userInfo.OGN_FG === '01'">
        <label class="signature-label">작성자서명</label>
        <VueSignaturePad
          ref="signaturePad"
          :options="{ backgroundColor: 'white', penColor: 'black' }"
          class="signature-pad"
        />
        <button @click="clearSignature" class="clear-btn">서명지우기</button>
        <button @click="saveSignTable" class="save-btn">내용 저장</button>
      </div>

      <div class="shop-rank-section" v-if="shopRankList.length > 0">
        <h3>매장 상세 리스트</h3>
        <ul class="shop-rank-list">
          <li v-for="item in shopRankList" :key="item.RANK_ROW" @click="applyShopRank(item)" class="shop-rank-item">
            <div class="rank">{{ item.RANK_ROW }}</div>
            <div class="info">
              <div class="shop">{{ item.SHOP_NM }} ({{ item.VAN_BIZ_NO }})</div>
              <div class="owner">{{ item.SIGN_NM }} / {{ item.AGE }}세 / {{ formatPhoneValue(item.TEL_NO) }}</div>
            </div>
            <button 
              v-if="(deleteFlag === 'Y' && item.SHOP_CD === userInfo.SHOP_CD) ||(deleteFlag === 'Y' && isSaveButtonVisible)" 
              @click.stop="deleteRankInfo(item.RANK_INFO_ID)"
            >
              삭제
            </button>
          </li>
        </ul>
      </div>
    </div>
    <!-- 그리드 데이터저장 -->
    <div v-if="isSaveButtonVisible" class="excel-save-area">
      <div class="manage-title">
        <span class="manage-icon">⚙</span>
        <div>
          <strong>관리자 데이터 관리</strong>
        </div>
      </div>
      <textarea 
        v-model="excelInput"
        placeholder="엑셀에서 데이터를 복사한 후 이곳에 붙여넣어 주세요."></textarea>
      <button @click="saveExcelData" class="excel-save-button">저장</button>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import axios from "axios";
import "ag-grid-community/styles/ag-grid.css";
import { themeBalham } from "ag-grid-community";
import VueSignaturePad from "vue3-signature-pad";

export default {
  name: "TsListPage",
  components: { AgGridVue, 
    VueSignaturePad,
  },
  props: {
    useNewGrid: Boolean,
    useNewSeListGrid: Boolean,
  },
  emits: ['topInfoChange', 'resetGridView'],
  data() {
    const now = new Date();
    // 이번 달  260929 추가
    const thisMonth = (now.getMonth() + 1).toString().padStart(2, "0");
    // 지난 달  260929 수정
    const prev = new Date(now);
    prev.setMonth(prev.getMonth() - 1);
    const previousMonth = (prev.getMonth() + 1).toString().padStart(2, "0");

    // 다음 달  260929 추가
    const next = new Date(now);
    next.setMonth(next.getMonth() + 1);
    const nextMonth = (next.getMonth() + 1).toString().padStart(2, "0");

    return {
      selectedBranch: "", // 선택된 본부
      branchList: [],
      selectedTeam: "", // 선택된 팀
      teamList: [], // 팀 목록
      teamSearch: "", // 매장 검색용
      userInfo: null, // 로그인한 사용자 정보

      previousMonth,
      nextMonth,

      formData: {
        SHOP_CD: "",
        SHOP_NM: "",
        VAN_BIZ_NO: "",
        SIGN_NM: "", 
        USER_SIGN:null,
        AGE: "",
        CAREER: "",
        // CURRENT_POSITION: "",  // CURRENT_POSITION 260915 제거
        HOW_SUCCESS:"", // HOW_SUCCESS 260915 추가
        TEL_NO: "",
        REG_DT: new Date().toISOString().slice(0,10),
        WANT_PROFIT_LEVEL: "",
        PROFIT_AMOUNT: "",
        PROFIT_READY: "",
        APPLY_PLAN: "",
        WANT_INCOME: "",
        KNOW_TOP_EARNERS: "",
        // RECOMMEND_EXPERIENCE: "",  // 260929 내용변경
        WANT_CNT: "",
        WANT_AMOUNT: "",
        SELF_INTRO: "",
        RECOMMENDER: ["", "", "", "", ""],
      },
      // 삭제 버튼 여부
      deleteFlag:"",

      // 매장별 랭킹 리스트 (화면 하단에 표시)
      shopRankList: [],

      excelInput:"",  //엑셀 붙여넣기

      rowHeight: window.innerWidth > 1024 ? 16 : 16, // 행 높이

      gridHeight: window.innerWidth > 1024 ? 22 : 22, // 그리드2 높이

      theme: themeBalham.withParams({
        fontFamily: "Malgun Gothic",
        headerHeight: 25,
        rowHeight: 16,
        borderColor: "#808080",
        wrapperBorder: true,
        headerRowBorder: true,
        headerColumnBorderHeight: "100%",
        rowBorder: { style: "solid", width: 1 },
        columnBorder: { style: "solid", width: 1 },
      }),

      gridApi: null,
      columnApi: null,

      monthlyTop20GridApi: null,
      monthlyTop20ColumnApi: null,
      monthlyTop20Data: [],
      monthlyTop20Defs: [
        {
          headerName: "순위",
          field: "RANK_ROW",
          flex: 0.2,
          cellStyle: { textAlign: "center", backgroundColor: "#ffffc0" },
        },
        // {
        //   headerName: "보증타입",
        //   field: "TRBIZ_TYPE",
        //   flex: 0.5,
        //   cellStyle: this.getProfitCellStyle,
        // },
        {
          headerName: "FC",
          field: "BRANCH_NM",
          flex: 0.2,
          cellStyle: this.getProfitCellStyle,
        },
        // {
        //   headerName: "점번",
        //   field: "VAN_BIZ_NO",
        //   flex: 0.5,
        //   cellStyle: this.getProfitCellStyle,
        // },
        {
          headerName: "점포명",
          field: "SHOP_NM",
          flex: 0.4,
          cellStyle: this.getProfitCellStyle,
        },
        {
          headerName: "사업주명",
          field: "EMP_NM",
          flex: 0.35,
          cellStyle: this.getProfitCellStyle,
        },
        {
          headerName: "나이",
          field: "AGE",
          flex: 0.2,
          cellStyle: this.getProfitCellStyle,
        },
        {
          headerName: "운영",
          field: "CAREER",
          flex: 0.2,
          cellStyle: this.getProfitCellStyle,
        },
        {
          headerName: "판매수량",
          field: "SALE_CNT",
          flex: 0.35,
          cellStyle: this.getProfitCellStyle,
          valueFormatter: (params) => {
            return Number(params.value).toLocaleString();
          },
        },
        // {
        //   headerName: "판매점수",
        //   field: "SALE_SCORE",
        //   width: 40,
        //   flex: 0.4,
        //   cellStyle: this.getProfitCellStyle,
        //   valueFormatter: (params) => {
        //     return Number(params.value).toLocaleString();
        //   },
        // },
        // {
        //   headerName: "당월적립금",
        //   field: "AMT_N1",
        //   width: 40,
        //   flex: 0.7,
        //   cellStyle: this.getProfitCellStyle,
        //   valueFormatter: (params) => {
        //     return Number(params.value).toLocaleString();
        //   },
        // },
        // {
        //   headerName: "벌어가져간금액",
        //   field: "AMT_N2",
        //   width: 40,
        //   flex: 0.7,
        //   cellStyle: this.getProfitCellStyle,
        //   valueFormatter: (params) => {
        //     return Number(params.value).toLocaleString();
        //   },
        // },
        {
          headerName: `${previousMonth}월 사업소득`,  //260929 월추가
          field: "AMT_SUM",
          flex: 0.6,
          cellStyle: this.getProfitCellStyle,
          valueFormatter: (params) => {
            return Number(params.value).toLocaleString() + "만원";
          },
        },
        {
          headerName: `${thisMonth}월 판매 수량과 수익 목표`,   //260929 월추가
          field: "SHOP_KPI",
          flex: 1.1,
          cellStyle: this.getProfitCellStyle,
          // valueFormatter: (params) => {
          //   return Number(params.value).toLocaleString();
          // },
        },
        {
          headerName: "사업주가 밝히는 사업 성공이유와방법",
          field: "SUCCESS_REASON",   
          flex: 5,                   
          // editable: true,            
          tooltipValueGetter: (params) => params.value,
          cellStyle: this.getProfitCellStyle,
        },
      ],
      monthlyTop20GridOptions: {
        tooltipShowMode: "whenTruncated",
        tooltipShowDelay: 0,
        defaultColDef: {
          wrapHeaderText: true,
          resizable: true,
          sortable: true,
          tooltipValueGetter: (params) => params.value,
          comparator: (valueA, valueB) => {
            const isANumber = !isNaN(parseFloat(valueA)) && isFinite(valueA);
            const isBNumber = !isNaN(parseFloat(valueB)) && isFinite(valueB);

            if (isANumber && isBNumber) {
              return valueA - valueB;
            }
            if (!isANumber && !isBNumber) {
              return String(valueA).localeCompare(String(valueB));
            }
            return isANumber ? -1 : 1;
          },
          headerStyle: {
            backgroundColor: "#ffffc0",
            color: "black",
          },
        },
        rowSelection: { mode: "singleRow", checkboxes: false },
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
        domLayout: "autoHeight",
      },
    };
  },

  created() {
    Promise.all([
      this.fetchMonthlyTop20(),
      this.FetchDeleteFlag(),
    ]);
  },

  mounted() {
    // localStorage에서 사용자 정보 불러오기
    const userInfoString = localStorage.getItem("userInfo");
    if (userInfoString) {
      this.userInfo = JSON.parse(userInfoString);
    }
    window.addEventListener("resize", this.handleResize);

    document.addEventListener("paste", this.handlePaste);
    
    this.fetchCenterList();
    if (this.userInfo?.OGN_FG === "01") {
      // 본부 선택 없이도 바로 팀 목록 불러오기
      this.fetchTeamList("00").then(() => {
        this.loadSignTableData();  
        this.formData.SHOP_CD = this.userInfo.SHOP_CD;
        // OGN_FG === '01' 사용자는 들어오자마자 자신의 매장으로 랭킹 조회
        this.fetchShopRankList(this.userInfo.SHOP_CD);
      });
    }
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
    document.removeEventListener("paste", this.handlePaste);
  },

  computed: {
    isSaveButtonVisible() {
      // '관리자'가 아닐 경우에만 저장 버튼을 표시합니다.
      return (
        this.userInfo &&
        ["관리자", "김완수", "이도건"].includes(
          this.userInfo.EMP_NM
        )
      );
    },
    top1Data() {
      return this.monthlyTop20Data.find(item => item.RANK_ROW === 1);
    },
    youngestData() {
      if (!this.monthlyTop20Data.length) return null;
      return this.monthlyTop20Data.reduce((min, item) => {
        return item.AGE < min.AGE ? item : min;
      }, this.monthlyTop20Data[0]);
    },
  },

  watch: {
    selectedBranch(newBranchCd) {
      // 본부가 선택되면 팀 목록을 불러옵니다.
      if (newBranchCd) {
        this.fetchTeamList(newBranchCd).then(() => {
          // 사용자가 직접 본부를 변경했을 때만 매장 선택을 초기화
          if (this.userInfo.OGN_FG === "00") {
            this.selectedTeam = "";
          }
        });
      } else {
        this.teamList = [];
        this.selectedTeam = "";
      }
    },
    selectedTeam(newShopCd) {
      if (newShopCd && newShopCd !== "00") {
        const team = this.teamList.find((t) => t.SHOP_CD === newShopCd);
        if (team) {
          const teamName = `(${team.VAN_BIZ_NO}) ${team.SHOP_NM}`;
          if (this.teamSearch !== teamName) {
            this.teamSearch = teamName;
          }
          if (this.selectedBranch === "전체") {
            this.selectedBranch = team.BRANCH_CD;
          }
          // 선택된 매장으로 랭킹 목록 조회
          this.fetchShopRankList(newShopCd);
        }
      } else {
        if (this.teamSearch !== "") {
          this.teamSearch = "";
        }
      }
    },
    // 금액이 입력되면 라디오 선택을 초기화
    'formData.PROFIT_AMOUNT'(newVal) {
      if (newVal) {
        this.formData.PROFIT_READY = null;
      }
    },
    // 라디오가 선택되면 금액 입력을 초기화
    'formData.PROFIT_READY'(newVal) {
      if (newVal !== null) {
        this.formData.PROFIT_AMOUNT = null;
      }
    },
  },

  methods: {
    formatPhoneValue(value) {
      let digits = (value || '').replace(/[^0-9]/g, '');
      if (digits.length <= 3) return digits;
      if (digits.length <= 7) return digits.replace(/(\d{3})(\d{1,4})/, '$1-$2');
      return digits.replace(/(\d{3})(\d{4})(\d{1,4})/, '$1-$2-$3');
    },

    // 매장 선택(datalist 변경) 처리
    handleTeamSelection() {
      const match = this.teamList.find(
        (t) => `(${t.VAN_BIZ_NO}) ${t.SHOP_NM}` === this.teamSearch
      );
      if (match) {
        this.selectedTeam = match.SHOP_CD;
      }
    },

    // 선택한 매장의 랭킹 리스트 가져오기
    async fetchShopRankList(shopCd) {
      try {
        if (!shopCd) {
          this.shopRankList = [];
          return;
        }
        const res = await axios.get('/api/tsListPage/fetchShopRanks', {
          params: { shopCd }
        });
        this.shopRankList = Array.isArray(res.data) ? res.data : [];
      } catch (err) {
        console.error('매장 랭킹 로딩 실패:', err);
        this.shopRankList = [];
      }
    },

    // 리스트에서 항목 클릭 시 폼에 값 세팅 // CURRENT_POSITION 260915 제거
    applyShopRank(item) {
      if (!item) return;
      this.formData.VAN_BIZ_NO = item.VAN_BIZ_NO || this.formData.VAN_BIZ_NO;
      this.formData.SHOP_NM = item.SHOP_NM || this.formData.SHOP_NM;
      this.formData.SIGN_NM = item.SIGN_NM || this.formData.SIGN_NM;
      this.formData.AGE = item.AGE || this.formData.AGE;
      this.formData.CAREER = item.CAREER || this.formData.CAREER;
      // this.formData.CURRENT_POSITION = item.CURRENT_POSITION || this.formData.CURRENT_POSITION;
      this.formData.HOW_SUCCESS = item.HOW_SUCCESS || this.formData.HOW_SUCCESS;
      if (item.TEL_NO) {
        this.formData.TEL_NO = this.formatPhoneValue(item.TEL_NO);
      }
      this.formData.REG_DT = new Date(item.REG_DT).toISOString().split("T")[0] || new Date(this.formData.REG_DT).toISOString().split("T")[0];
      
      // 추가로 필요하면 다른 필드도 설정 가능
      this.formData.WANT_PROFIT_LEVEL = item.WANT_PROFIT_LEVEL || this.formData.WANT_PROFIT_LEVEL;
      this.formData.PROFIT_READY = item.PROFIT_READY || this.formData.PROFIT_READY;
      this.formData.PROFIT_AMOUNT = item.PROFIT_AMOUNT || this.formData.PROFIT_AMOUNT;
      this.formData.APPLY_PLAN = item.APPLY_PLAN || this.formData.APPLY_PLAN;
      this.formData.WANT_INCOME = item.WANT_INCOME || this.formData.WANT_INCOME;
      this.formData.KNOW_TOP_EARNERS = item.KNOW_TOP_EARNERS || this.formData.KNOW_TOP_EARNERS;
      // this.formData.RECOMMEND_EXPERIENCE = item.RECOMMEND_EXPERIENCE || this.formData.RECOMMEND_EXPERIENCE;  //260929 내용변경
      this.formData.WANT_CNT = item.WANT_CNT || this.formData.WANT_CNT;
      this.formData.WANT_AMOUNT = item.WANT_AMOUNT || this.formData.WANT_AMOUNT;
      this.formData.SELF_INTRO = item.SELF_INTRO || this.formData.SELF_INTRO;
      this.formData.RECOMMENDER = item.RECOMMENDER ? item.RECOMMENDER.split(",").map(str => str.trim()) : this.formData.RECOMMENDER;
      this.formData.USER_SIGN = item.USER_SIGN || this.formData.USER_SIGN;
    },

    async fetchCenterList() {
      try {
        const res = await axios.get("/api/tsListPage/centerList");
        this.branchList = res.data;
        if (this.branchList.length > 0) {
            this.selectedBranch = this.branchList[0].BRANCH_CD;
        }

      } catch (error) {
        console.error("본부 목록 로딩 실패:", error);
        alert("본부 목록을 불러오는 데 실패했습니다.");
      }
    },
    async fetchTeamList(branchCd) {
      try {
        const res = await axios.get(
          `/api/tsListPage/teamList?branchCd=${branchCd}`
        );
        this.teamList = res.data;
      } catch (error) {
        console.error("팀 목록 로딩 실패:", error);
        this.teamList = [];
      }
    },
    async fetchMonthlyTop20() {
      try {
        const response = await axios.get("/api/tsListPage/fetchMonthlyTopData");
        this.monthlyTop20Data = response.data.map(row => ({
          ...row,
          // AMT_N1: Number(row.AMT_N1),
          // AMT_N2: Number(row.AMT_N2),
          AMT_SUM: Number(row.AMT_SUM),
        }));
      } catch (error) {
        console.error("Failed to load monthly top 20:", error);
        alert("데이터 불러오기 중 오류가 발생했습니다.");
      }
    },
    
    async FetchDeleteFlag() {
      try {
        const response = await axios.get("/api/tsListPage/fetchDeleteFlag");
        this.deleteFlag = response.data.recordset[0].TRBIZ_TYPE
      } catch (error) {
        console.error("Failed to load deleteFlag:", error);
        alert("데이터 불러오기 중 오류가 발생했습니다.");
      }
    },

    async saveDeleteFlag(){
      this.deleteFlag = this.deleteFlag === 'Y' ? 'N' : 'Y'

      try {
        // 서버에 반영 
        await axios.put(`/api/tsListPage/saveDeleteFlag`, { deleteFlag: this.deleteFlag} );
        alert('저장되었습니다');
      } catch (err) {
        alert('저장 실패: ' + err);
      }
      
    },

    async deleteRankInfo(rankInfoId) {
      if (!confirm("정말 삭제하시겠습니까?")) return;

      try {
        await axios.delete(`/api/tsListPage/deleteRankInfo/${rankInfoId}`);
        alert("삭제되었습니다.");
        // 삭제 후 리스트 갱신
        this.fetchShopRankList(this.userInfo.SHOP_CD);
      } catch (error) {
        console.error("Failed to delete rank:", error);
        alert("삭제 중 오류가 발생했습니다.");
      }
    },

    async loadSignTableData() {
      try {
        const matched = this.teamList.find(item => item.SHOP_CD === this.userInfo.SHOP_CD);

        // 찾은 항목이 있으면 그 안의 VAN_BIZ_NO를 formData에 세팅
        if (matched) {
          this.formData.VAN_BIZ_NO = matched.VAN_BIZ_NO;
        }
        // 로그인 매장 정보 자동 세팅
        this.formData.SHOP_NM = this.userInfo.SHOP_NM;
        this.formData.SHOP_CD = this.userInfo.SHOP_CD;

        // 해당 월 데이터 불러오기
        // const response = await axios.get("/api/signTable/getMonthly", {
        //   params: { shopNm: this.formData.SHOP_NM }
        // });
        // if (response.data) {
        //   this.formData = { ...this.formData, ...response.data };
        // }
      } catch (error) {
        console.error("데이터 불러오기 실패:", error);
      }
    },

    async saveSignTable() {
      try {
        // 필수 입력값 체크 // CURRENT_POSITION 260915 제거
        const requiredFields = {
          SHOP_CD: "매장코드",
          SHOP_NM: "매장명",
          VAN_BIZ_NO: "점번",
          SIGN_NM: "성명",
          AGE: "나이",
          CAREER: "타이어경력",
          // CURRENT_POSITION: "현재직위",
          HOW_SUCCESS: "성공사업주 하고 있는것",
          TEL_NO: "연락처",
          REG_DT: "작성일자",
          SELF_INTRO: "4번",
          WANT_PROFIT_LEVEL: "7번",
          APPLY_PLAN: "8번",
          WANT_INCOME: "9번",
          KNOW_TOP_EARNERS: "10번",
          // RECOMMEND_EXPERIENCE: "11번",  // 260929 내용변경
          WANT_CNT: "11번 수량",
          WANT_AMOUNT: "11번 금액",
          RECOMMENDER: "12번"
        };

        let missing = [];
        for (const key in requiredFields) {
          if (key === "RECOMMENDER") {
              // 배열 검사: 모든 요소가 빈 문자열이면 누락 처리
              const hasValue = Array.isArray(this.formData.RECOMMENDER) &&
                              this.formData.RECOMMENDER.some(v => v && v.trim() !== "");
              if (!hasValue) {
                missing.push(requiredFields[key]);
              }
            } else {
              if (!this.formData[key] || this.formData[key].toString().trim() === "") {
                missing.push(requiredFields[key]);
              }
            }
        }

        const hasProfit =
          (this.formData.PROFIT_READY !== null && this.formData.PROFIT_READY !== "") ||
          (this.formData.PROFIT_AMOUNT !== null && this.formData.PROFIT_AMOUNT.toString().trim() !== "");

        if (!hasProfit) {
          missing.push("6번 보증금 준비 둘중 하나");
        }
        // 빠진 값이 있으면 alert
        if (missing.length > 0) {
          alert("다음 항목을 입력해주세요:\n- " + missing.join("\n- "));
          return;
        }

        // 서명 확인
        if (this.$refs.signaturePad) {
          const pad = this.$refs.signaturePad;
          if (pad.isEmpty()) {
            alert("서명을 작성해주세요.");
            return;
          }
        }
        const canvas = this.$refs.signaturePad.$el.querySelector("canvas");
        const signatureData = canvas.toDataURL("image/png");
        const payload = { 
          ...this.formData,
          TEL_NO: (this.formData.TEL_NO || '').replace(/-/g, ''),
          signatureData: signatureData,
          userId: this.userInfo ? this.userInfo.userId : "Unknown", 
        };

        await axios.post("/api/tsListPage/saveMonthly", payload);
        alert("성공적으로 저장되었습니다.");
        // 저장 후 초기화
        this.resetForm();
        this.clearSignature();
        this.fetchShopRankList(this.userInfo.SHOP_CD);
        this.loadSignTableData();
      } catch (error) {
        console.error("저장 실패:", error);
        alert("저장 중 오류가 발생했습니다.");
      }
    },

    resetForm() {
      this.formData = {
        PROFIT_AMOUNT: "",
        PROFIT_READY: "",
        WANT_PROFIT_LEVEL: "",
        APPLY_PLAN: "",
        WANT_INCOME: "",
        KNOW_TOP_EARNERS: "",
        // RECOMMEND_EXPERIENCE: "",  // 260929 내용변경
        WANT_CNT: "",
        WANT_AMOUNT: "",
        SELF_INTRO: "",
        RECOMMENDER: ["", "", "", "", ""],
        VAN_BIZ_NO: "",
        SHOP_NM: "",
        SIGN_NM: "",
        AGE: "",
        CAREER: "",
        // CURRENT_POSITION: "",  // CURRENT_POSITION 260915 제거
        HOW_SUCCESS: "",  // HOW_SUCCESS 260915 추가
        TEL_NO: "",
        REG_DT: new Date().toISOString().slice(0,10),
      };
    },

    clearSignature() {
      this.$refs.signaturePad.clearSignature();
      // this.signatureDataUrl = "";
    },

    getProfitCellStyle(params) {
      const columnId = params.column.colId;
      const value = params.value;
      const style = {};

      if (params.node.rowIndex + 1 === 10) {
        style.background = "#cad3fc"; // 직접 지정
      }

      if (isNaN(value)) {
        style.textAlign = "center";
      } else {
        style.textAlign = "right";
      }
      if(columnId == "SUCCESS_REASON"){
        style.textAlign = "left";
        style.paddingLeft = "8px";
      }
      if(columnId == "AMT_SUM"){
        style.paddingRight = "8px";
      }

      return style; // 기본 스타일
    },

    handleResize() {
      const isWide = window.innerWidth > 1024;
      const newRowHeight = isWide ? 16 : 16;
      const newGridHeight = isWide ? 22 : 22;
      if (this.rowHeight !== newRowHeight) {
        this.rowHeight = newRowHeight;
        if (this.gridApi) this.gridApi.resetRowHeights();
      }
      if (this.gridHeight !== newGridHeight) {
        this.gridHeight = newGridHeight;
      }
    },

    onMonthlyTop20GridReady(params) {
      this.monthlyTop20GridApi = params.api;
      this.monthlyTop20ColumnApi = params.columnApi;
    },

    async saveExcelData() {
      if (!this.excelInput.trim()) {
        alert("데이터가 없습니다.");
        return;
      }

      // 줄 단위로 분리
      const lines = this.excelInput.trim().split("\n");

      // 빈 줄 제거
      const dataRows = lines.filter(line => line.trim() !== "");

      const rowData = dataRows.map(line => {
        const cols = line.split("\t"); // 엑셀 붙여넣기는 탭(\t) 구분

        return {
          RANK_ROW: cols[0],
          BRANCH_NM: cols[1],
          SHOP_NM: cols[2],
          EMP_NM: cols[3],
          AGE: cols[4],
          CAREER: cols[5],
          SALE_CNT: cols[6],
          AMT_SUM: cols[7].replace(/,/g, "").trim(),
          SHOP_KPI: cols[8],
          SUCCESS_REASON: cols[9],
        };
      });

      const payload = {
        gridData: rowData,
        userId: this.userInfo ? this.userInfo.userId : "Unknown",
      };

      if (!confirm("저장하시겠습니까?")) return;
      try {
        await axios.post("/api/tsListPage/saveTsList", payload);
        alert("성공적으로 저장되었습니다.");
      } catch (error) {
        console.error("Failed to save excel data:", error);
        alert("데이터 저장 중 오류가 발생했습니다.");
      }
    },

    copyMonthlyTop20Data() {
      this.copyData(this.monthlyTop20GridApi);
    },

    copyData(gridApi) {
      const csvData = gridApi.getDataAsCsv({
        // 헤더 가공: \n 제거
        processHeaderCallback: (params) => {
          const def = params.column.getColDef();
          const header = def.headerName ?? def.field ?? "";
          return String(header).replace(/\r?\n/g, " "); // 줄바꿈 → 공백
        },
        // 셀 값 가공(필요하면): 셀 안의 줄바꿈도 제거
        processCellCallback: (params) => {
          const v = params.value;
          if (v == null) return "";
          return String(v).replace(/\r?\n/g, " ");
        },
        // 엑셀 친화 옵션
        columnSeparator: "\t", // 탭 구분 → 엑셀에 바로 셀 분리
        suppressQuotes: true, // 큰따옴표 억제(헤더에 따옴표 생기는 문제 방지)
      });

      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(csvData)
          .then(() => alert("복사되었습니다."))
          .catch((err) => console.error("Clipboard copy failed: ", err));
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = csvData;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        alert("복사되었습니다.");
      }
    },

    handlePaste(event) {
      // 현재 포커스된 Element가 ag-grid 내부인지 확인
      const focusedElement = document.activeElement;
      const monthlyGrid = document.querySelector(".monthly-grid");

      let targetDefs;
      let targetApi;

      // 포커스된 그리드 확인
      if (monthlyGrid?.contains(focusedElement)) {
        targetDefs = this.monthlyTop20Defs;
        targetApi = this.monthlyTop20GridApi;
      } else {
        return; // 그리드 외부면 리턴
      }

      // 클립보드 데이터 가져오기
      const clipboardData = event.clipboardData.getData("text");
      const rows = clipboardData.split(/\r\n|\n|\r/);

      // 현재 선택된 셀의 위치 가져오기
      const focusedCell = targetApi.getFocusedCell();
      if (!focusedCell) return;

      const startRow = focusedCell.rowIndex;
      const startCol = targetDefs.findIndex(
        (col) => col.field === focusedCell.column.colId
      );

      // 데이터 붙여넣기
      rows.forEach((row, rowIndex) => {
        const cells = row.split("\t");
        cells.forEach((cell, colIndex) => {
          const rowNode = targetApi.getDisplayedRowAtIndex(startRow + rowIndex);
          if (!rowNode) return;

          const colDef = targetDefs[startCol + colIndex];
          if (!colDef) return;

          const colId = colDef.field;

          if (colId) {
            let value = cell.trim();
            // valueFormatter가 있는 컬럼은 숫자로 변환 (숫자 컬럼으로 가정)
            if (colDef.valueFormatter || colDef.cellDataType === 'number') {
              value = value === "" ? null : Number(value);
            }
              
            rowNode.setDataValue(colId, value);
          }
        });
      });

      event.preventDefault(); // 브라우저 기본 붙여넣기 동작막기
    },

    async saveGridData(gridApi) {
      if (!gridApi) {
        alert("그리드를 찾을 수 없습니다.");
        return;
      }

      const confirmed = window.confirm("저장하시겠습니까?");
      if (!confirmed) return;

      const rowData = [];
      gridApi.forEachNode((node) => {
        // 점포명이 있는 유효한 데이터만 추출합니다.
        if (node.data && node.data.SHOP_NM) {
          rowData.push(node.data);
        }
      });

      if (rowData.length === 0) {
        alert("저장할 데이터가 없습니다.");
        return;
      }

      const payload = {
        gridData: rowData,
        // 저장하는 사용자의 정보를 함께 보냅니다. (백엔드 API 명세에 맞게 수정)
        userId: this.userInfo ? this.userInfo.userId : "Unknown",
      };

      try {
        // 실제 사용하는 API 엔드포인트로 교체해야 합니다.
        await axios.post("/api/tsListPage/saveTsList", payload);
        alert("성공적으로 저장되었습니다.");
      } catch (error) {
        console.error("Failed to save grid data:", error);
        alert("데이터 저장 중 오류가 발생했습니다.");
      }
    },

  },
};
</script>

<style scoped>
.ts-list-page {
  display: flex;
  flex-direction: column;
  padding-left: 5px;
  padding-right: 5px;
}
.ts-list-middle-table {
  flex: 1;
  width: 100%;
}

.info-section {
  display: flex;
  align-items: center;
  gap: 6px; /* 요소 간격 */
}

.info-label {
  font-weight: bold;
  margin-left: 6px;
  white-space: nowrap; /* 줄바꿈 방지 */
}

.branch-select,
.team-select {
  padding: 3px 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  min-width: 180px;
  font-size: 12px;
}

.branch-select:disabled,
.team-select:disabled {
  background-color: #f5f5f5;
  color: #999;
  cursor: not-allowed;
}

.team-select::placeholder {
  color: #aaa;
}

.button-group {
  margin-left: auto; /* 버튼 그룹을 오른쪽 끝으로 밀어냄 */
  display: flex;
  gap: 6px;
}

.tsList-button {
  padding: 4px 8px;
  font-size: 0.8rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #f9f9f9;
  cursor: pointer;
}

:deep(.ag-ts-balham) {
  /* font-size: 0.95rem; */
  --ag-cell-horizontal-padding: 2px; /* 셀 내부 좌우 패딩 */
  --ag-cell-vertical-padding: 1px; /* 셀 내부 상하 패딩 */
}

:deep(.ag-ts-balham .ag-header-cell-comp-wrapper) {
  display: flex;
  align-items: center;
  justify-content: center;
}
/* grid 헤더 텍스트 정렬 */
:deep(.ag-ts-balham .ag-header-cell-label) {
  justify-content: center !important;
  white-space: pre-line;
  align-items: center !important;
  font-weight: normal;
  font-size: 0.75rem;
}

:deep(.ag-ts-balham .ag-cell) {
  font-size: 0.75rem;
  text-align: right;
  /* padding-right: 3px; */
}

/* 1024px 초과일 때 폰트/행 높이 증가 */
@media (min-width: 1025px) {
  :deep(.ag-ts-balham .ag-cell) {
    font-size: 0.8rem;
  }
  :deep(.ag-ts-balham .ag-header-cell-text) {
    font-size: 0.8rem;
  }

}

.meeting-wrap{
  border:2px solid #000;
  padding:2px;
  background:#fff;
  font-size: 0.9rem;
}

.meeting-info,
.meeting-table{
    width:100%;
    border-collapse:collapse;
    margin-bottom:2px;
}

.meeting-info th,
.meeting-info td,
.meeting-table th,
.meeting-table td{
    border:1px solid #444;
    padding:2px;
}

.meeting-info th,
.meeting-table th{
    background:#f3f3f3;
    text-align:center;
}

.no{
    text-align:center;
    font-weight:bold;
}

.meeting-info input{
    width:100%;
    border:none;
    outline:none;
    height:12px;
    box-sizing:border-box;
}

.radio-group {
  display: flex;
  justify-content: center;   /* 가로 가운데 */
  align-items: center;       /* 세로 가운데 */
  gap: 20px;                 /* 버튼 간격 */
}

.radio-group {
  display: grid;
  grid-template-columns: 140px 140px 140px;
  align-items: center;
}

.radio-group label {
  display: flex;
  align-items: center;
  margin: 0;
  white-space: nowrap;
}

.radio-line {
  display: flex;              /* 한 줄로 정렬 */
  justify-content: center;
  align-items: center;
  gap: 20px;                  /* 요소 간격 */
}

.amount-box {
  display: inline-flex;        /* input과 '만원' 붙여서 */
  align-items: center;
}

.amount-box span {
  margin-left: 4px;
}

/* =========================================================
   하단 정보 + 서명 영역
========================================================= */

.sign-table {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  border:1px solid #444;
  background-color: #fafafa;
  font-size: 0.9rem;

  box-sizing: border-box;
  overflow: hidden;
}

/* 공통 */
.sign-table table {
  border-collapse: collapse;
  min-width: 0;
}

.sign-table th,
.sign-table td {
  border: 1px solid #ddd;
  text-align: center;
  box-sizing: border-box;
}

/* 1. 성공사업주 내용 */
.sign-table .memo-table {
  flex: 0 0 40%;
  width: 40%;
}

.sign-table .memo-table th {
  width: 18%;
  background-color: #f0f0f0;
  font-weight: bold;
  color: #333;
  line-height: 1.3;
}

.sign-table .memo-table td {
  width: 62%;
  padding: 4px;
}

.sign-table .memo-input {
  width: 100%;
  height: 85px;       /* 약 3줄 */
  min-height: 72px;
  resize: none;
  box-sizing: border-box;

  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 3px;

  font-family: inherit;
  font-size: 0.9rem;
  line-height: 1.4;
  vertical-align: top;
}

/* 2. 정보 입력 */
.sign-table .info-table {
  flex: 0 0 40%;
  width: 40%;
}

.sign-table .info-table th {
  width: 15%;
  background-color: #f0f0f0;
  font-weight: bold;
  color: #333;
  white-space: nowrap;
}

.sign-table .info-table td {
  width: 35%;
}

.sign-table .info-table input {
  width: 100%;
  height: 30px;
  padding: 2px 2px;

  border: none;
  border-bottom: 1px solid #555;
  background: transparent;

  box-sizing: border-box;
  text-align: center;
  font-size: 0.9rem;
}

.career-box {
  display: flex;
  align-items: center;
  width: 100%;
}

.career-box input {
  width: 100%;
  flex: 1;
}

.career-box span {
  flex-shrink: 0;
  margin-left: 4px;
  white-space: nowrap;
}
/* 3. 서명 */
.sign-table .sign-row {
  display: flex;
  flex-direction: column; /* 위아래 배치 */
  gap: 10px;
}

.sign-name {
  display: flex;
  flex-direction: row; /* 작성자/성명 한 줄 */
  align-items: center;
  gap: 5px;
}

.sign-image {
  display: flex;
  justify-content: center;
}


.sign-table .sign-row label {
  font-weight: bold;
  color: #444;
}

.sign-table .sign-row img {
  width: 100%;
  height: 85px;
  max-height: 85px;

  border: 1px solid #ccc;
  border-radius: 4px;

  object-fit: contain;
  background: white;
  box-sizing: border-box;
}

.signature-row {
  display: flex;
  align-items: center;
  justify-content: center; /* 화면 가운데 정렬 */
  margin-top: 2px;
}

.sign-table input {
  border: none;              /* 기본 테두리 제거 */
  border-bottom: 1px solid #333; /* 밑줄만 표시 */
  outline: none;             /* 포커스 시 파란 테두리 제거 */
  background: transparent;   /* 배경 투명하게 */
  text-align: center;       
  font-size: 0.9rem; 
}

.signature-label {
  display: flex;              /* 박스 내부 정렬 */
  align-items: center;        /* 세로 가운데 */
  justify-content: center;    /* 가로 가운데 */
  font-weight: bold;
  background-color: #f5f5f5;
  width: 50px;               /* 박스 폭 */
  height: 150px;              /* 서명 패드와 동일 높이 */
  border: 1px solid #ccc;
  border-radius: 4px;
  writing-mode: vertical-rl; /* 글자를 세로로 표시 */
  text-orientation: upright; /* 글자가 뒤집히지 않고 똑바로 보이게 */
}

.signature-pad {
  border: 1px solid #ccc;
  width: 400px;
  height: 100px;
}

.clear-btn {
  height: 150px; /* 서명 패드와 같은 높이 */
  background-color: #faf8a0;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  margin-right: 100px;
  writing-mode: vertical-rl; /* 글자를 세로로 표시 */
  text-orientation: upright; /* 글자가 뒤집히지 않고 똑바로 보이게 */
}

.save-btn {
  background-color: #4CAF50;
  color: white;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}
.save-btn:hover {
  background-color: #45a049;
}

.shop-rank-section {
  margin-top: 12px;
  padding: 8px;
  border-top: 1px solid #ddd;
}
.shop-rank-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.shop-rank-item {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 6px;
  border: 1px solid #eee;
  cursor: pointer;
  background: #fff;
}
.shop-rank-item:hover { background:#f7f7f7 }
.shop-rank-item .rank {
  width: 32px;
  text-align: center;
  font-weight: bold;
}
.shop-rank-item .info .shop {
  font-weight: bold;
}
.shop-rank-item .info .owner {
  font-size: 0.9rem;
  color: #666;
}
.shop-rank-item button {
  margin-left: 20px;
  padding: 4px 10px;
  border: 1px solid #d9534f;
  background-color: #d9534f;
  color: #fff;
  font-size: 0.85rem;
  border-radius: 4px;
  cursor: pointer;
}

.shop-rank-item button:hover {
  background-color: #c9302c;
}

/* 엑셀 데이터 저장 영역 */
.manage-title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}

.manage-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 34px;
  height: 34px;

  background: #f1f5f9;
  border-radius: 9px;

  font-size: 1rem;
}

.manage-title strong {
  display: block;
  font-size: 1rem;
}

/* 엑셀 붙여넣기 영역 */
.excel-save-area {
  width: 100%;
  box-sizing: border-box;

  display: flex;
  align-items: stretch;
  gap: 6px;

  padding: 6px;

  background: #f5f7fa;
  border: 1px solid #d9dee5;
  border-radius: 6px;
}

/* 엑셀 붙여넣기 영역 */
.excel-save-area textarea {
  flex: 1;
  height: 70px;
  box-sizing: border-box;
  padding: 8px;
  resize: none;
  border: 1px solid #cfd5dc;
  border-radius: 4px;
  background: #fff;
  color: #333;
  font-family: "Malgun Gothic", sans-serif;
  font-size: 13px;
  line-height: 1.4;
  outline: none;
}

.excel-save-area textarea:focus {
  border-color: #5b8def;
  box-shadow: 0 0 0 2px rgba(91, 141, 239, 0.12);
}

/* 저장 버튼 */
.excel-save-button {
  width: 70px;
  min-width: 70px;
  border: 1px solid #4a78d0;
  border-radius: 4px;
  background: #5b8def;
  color: #fff;
  font-family: "Malgun Gothic", sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.excel-save-button:hover {
  background: #4a78d0;
}

@media print {
  .no-print {
    display: none;
  }
}
</style>
